/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Tue Feb 11 2025
 **/

import { useTheme } from "@emotion/react";
import { Column, Icon, Typography } from "@/frameworks/designStuff/components";

import { MobileCloseWrap, MobileViewerFooterWrap, ToolButtonWrap, ViewerHeaderWrap } from "./emotion";
import { ViewerHeaderProps } from "./HeaderWrapper";

export default function HeaderMobile({
	fileName,
	publisherName,
	onClickClose,
	onClickDownload,
	onClickDelete,
	mimeType
}: ViewerHeaderProps) {
	const theme = useTheme();

	return (
		<>
			<ViewerHeaderWrap
				verticalAlign="center"
				horizonAlign="distribute"
				css={{
					boxShadow: "0px 4px 8px 0px #0000001F,0px 0px 4px 0px #0000000A",
					justifyContent: "center"
				}}
			>
				<Column verticalAlign="center" css={{ maxWidth: "65%", textAlign: "center" }}>
					<Typography.div
						typoSize="Body2"
						typoColor="neutral_00_100"
						ellipsis
						maxLine={1}
						css={{ width: "100%" }}
					>
						{fileName}
					</Typography.div>
					<Typography.div
						typoSize="Body4"
						typoColor="neutral_00_100"
						ellipsis
						maxLine={1}
						css={{ width: "100%" }}
					>
						{publisherName}
					</Typography.div>
				</Column>
				<MobileCloseWrap>
					{onClickClose && (
						<ToolButtonWrap onClick={onClickClose}>
							<Icon name="Close24" size="24" fill={theme.colors["neutral_00_100"]} />
						</ToolButtonWrap>
					)}
				</MobileCloseWrap>
			</ViewerHeaderWrap>
			<MobileViewerFooterWrap style={{ bottom: mimeType === "video" ? "42px" : "12px" }}>
				{onClickDelete && (
					<ToolButtonWrap onClick={onClickDelete}>
						<Icon name="Delete24" size="24" fill={theme.colors["warning_40_100"]} />
					</ToolButtonWrap>
				)}
				{onClickDownload && (
					<ToolButtonWrap onClick={onClickDownload}>
						<Icon name="Download24" size="24" fill={theme.colors["neutral_00_100"]} />
					</ToolButtonWrap>
				)}
			</MobileViewerFooterWrap>
		</>
	);
}
